import React, { useState, useContext} from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../AuthContext';
import s from '../styles/login.module.css'; 


function Login() {
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { fetchCurrentUser } = useContext(AuthContext); // Получаем функцию обновления пользователя
  
  const handleLogin = async (e) => {
    e.preventDefault(); // Предотвращаем отправку формы
    try {
      const response = await fetch('/api/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({login, password }),
      });

      if (!response.ok) {
        const data = await response.json();
        setError(data.error || 'Login failed');
        return;
      }

      // Если запрос успешен
      const data = await response.json();
      console.log('Login successful:', data);
          // 1) Сохраняем токен в localStorage
     if (data.token) {
       localStorage.setItem('user_token', data.token);
       // Можем также сохранить user_role, если нужно
       localStorage.setItem('user_role', data.user_role);
     }
      // Обновляем данные текущего пользователя
      await fetchCurrentUser();
      
      // Перенаправляем пользователя
      navigate('/dashboard');


    } catch (err) {
      setError('Error logging in');
    }
  };

  return (
    <div>
      <div>
      <img className={s.logo_maz} src="/start_logo.svg" alt="Логотип" />

      </div>
      <div className={s.login_container}>
        <div className={s.login_form}>
          <form onSubmit={handleLogin}>
            <input
              type="login"
              placeholder="Логин"
              value={login}
              onChange={(e) => setLogin(e.target.value)}
              autoComplete="login"
              required
            />
            <input
              type="password"
              placeholder="Пароль"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
            />
            <div className={s.link}>
              <Link style={{ color: 'white' }}>Забыли пароль?</Link>
            </div>
            <button type="submit">Войти</button>
            {error && <p>{error}</p>}
          </form>

          {/* Кнопка входа через Google */}
          <div id="googleSignInDiv" className={s.google_sign_in}></div>
        </div>
      </div>
    </div>
  );
}

export default Login;
